// Import all required block components
import dynamic from "next/dynamic";

const Calculator = dynamic(() => import("./calculator"));
const CalculatorV2 = dynamic(() => import("./calculator-v2"));
const CardGrid = dynamic(() => import("./card-grid"));
const Careers = dynamic(() => import("./careers"));
const CopyCentered = dynamic(() => import("./copy-centered"));
const CopyThreeColumn = dynamic(() => import("./copy-three-columns"));
const CopyFourColumn = dynamic(() => import("./copy-four-columns"));
const CopyTwoColumn = dynamic(() => import("./copy-two-columns"));
const CTA = dynamic(() => import("./cta"));
const CTAForm = dynamic(() => import("./cta-form"));
const CTACompact = dynamic(() => import("./cta-compact"));
const DNAImageSlider = dynamic(() => import("./dna-image-slider"));
const DNASpacer = dynamic(() => import("./dna-spacer"));
const eBookPreview = dynamic(() => import("./ebook-preview"));
const FAQ = dynamic(() => import("./faq"));
const FeatureGroups = dynamic(() => import("./feature-groups"));
const FeatureTable = dynamic(() => import("./feature-table"));
const FeatureValue = dynamic(() => import("./feature-value"));
const G2Awards = dynamic(() => import("./g2-awards"));
const G2Review = dynamic(() => import("./g2-review"));
const HeadingContent = dynamic(() => import("./heading-content"));
const HTML = dynamic(() => import("./html"));
const HubSpotForm = dynamic(() => import("./hubspot-form"));
const ImageColumns = dynamic(() => import("./image-columns"));
const LogoGarden = dynamic(() => import("./logo-garden"));
const LogoGardenCarousel = dynamic(() => import("./logo-garden-carousel"));
const MarqueeSimple = dynamic(() => import("./marquee-simple"));
const MarqueeFeature = dynamic(() => import("./marquee-feature"));
const MarqueeHomepageFeature = dynamic(() => import("./marquee-homepage-feature"));
const MarqueeHomepage = dynamic(() => import("./marquee-homepage"));
const RelatedResources = dynamic(() => import("./related-resources"));
const RelatedResourcesSlider = dynamic(() => import("./related-resources-slider"));
const RichText = dynamic(() => import("./rich-text"));
const Solutions = dynamic(() => import("./solutions"));
const Testimonial = dynamic(() => import("./testimonial"));
const TestimonialBlock = dynamic(() => import("./testimonial-block"));
const TestimonialGrid = dynamic(() => import("./testimonial-grid"));
const TestimonialCarousel = dynamic(() => import("./testimonial-carousel"));
const ValueGrid = dynamic(() => import("./value-grid"));
const ValueIcons = dynamic(() => import("./value-icons"));
const ValueGroups = dynamic(() => import("./value-groups"));
const ValueProp = dynamic(() => import("./value-prop"));
const VideoGrid = dynamic(() => import("./video-grid"));

// Register the block component in this object
// If the block isn't registered here, it will not render
// on the frontend
export const blockTypes = {
    calculator: Calculator,
    "calculator-v2": CalculatorV2,
    "card-grid": CardGrid,
    careers: Careers,
    "copy-centered": CopyCentered,
    "copy-four-column": CopyFourColumn,
    "copy-three-column": CopyThreeColumn,
    "copy-two-column": CopyTwoColumn,
    cta: CTA,
    "data-banner": CTA,
    "cta-form": CTAForm,
    "cta-compact": CTACompact,
    "dna-image-slider": DNAImageSlider,
    "dna-spacer": DNASpacer,
    "ebook-preview": eBookPreview,
    faq: FAQ,
    "feature-groups": FeatureGroups,
    "feature-table": FeatureTable,
    "feature-value": FeatureValue,
    "g2-awards": G2Awards,
    "g2-review": G2Review,
    "heading-content": HeadingContent,
    html: HTML,
    "hubspot-form": HubSpotForm,
    "image-columns": ImageColumns,
    "logo-garden": LogoGarden,
    "logo-garden-carousel": LogoGardenCarousel,
    "marquee-simple": MarqueeSimple,
    "marquee-feature": MarqueeFeature,
    "marquee-homepage-feature": MarqueeHomepageFeature,
    "marquee-homepage": MarqueeHomepage,
    "related-resources": RelatedResources,
    "related-resource-slider": RelatedResourcesSlider,
    "rich-text": RichText,
    solutions: Solutions,
    testimonial: Testimonial,
    "testimonial-block": TestimonialBlock,
    "testimonial-grid": TestimonialGrid,
    "testimonial-carousel": TestimonialCarousel,
    "value-icons": ValueIcons,
    "value-grid": ValueGrid,
    "value-groups": ValueGroups,
    "value-prop": ValueProp,
    "video-grid": VideoGrid,
};

/**
 * Check if a given block ID has a registered component
 * @param {String} blockId
 */
export const hasBlock = (blockId) => {
    if (Object.prototype.hasOwnProperty.call(blockTypes, blockId))
        return blockTypes[blockId];
    else return false;
};

export default function Blocks({
    blocks = [],
    prioritizeInitialBlocks = false,
    priorityCount = 3
}) {
    if (!blocks || !blocks.length) return null;

    return (
        <>
            {blocks.map((block, i) => {
                const $blockComponent = hasBlock(block.acf_fc_layout);

                if (!$blockComponent) return null;

                return (
                    <$blockComponent
                        block={block}
                        index={i}
                        isEarlyBlock={prioritizeInitialBlocks && i < priorityCount}
                        isLcpCandidate={prioritizeInitialBlocks && i === 0}
                        key={i}
                    />
                );
            })}
        </>
    );
}
